module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.records,
      "data-app": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.client.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.campaign.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status == 1 ? 'Approved' : 'Submitted'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTime")(props.item.createdAt)))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Payment Detail",
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showModalEdit(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1)], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Payment Records found!")]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), (_vm.selectedRecord && _vm.selectedRecord.id) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.viewPaymentDetailDialog),
      callback: function($$v) {
        _vm.viewPaymentDetailDialog = $$v
      },
      expression: "viewPaymentDetailDialog"
    }
  }, [_c('v-card', [_c('form', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Payment Record Details")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Client")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v(_vm._s(_vm.selectedRecord.client.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Campaign")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v(_vm._s(_vm.selectedRecord.campaign.name))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.paymentStatus,
      "item-text": "text",
      "item-value": "value",
      "label": "Status"
    },
    model: {
      value: (_vm.selectedRecord.status),
      callback: function($$v) {
        _vm.$set(_vm.selectedRecord, "status", $$v)
      },
      expression: "selectedRecord.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hint": "Insert the amount you need to submit (SGD)",
      "required": ""
    },
    model: {
      value: (_vm.selectedRecord.amount),
      callback: function($$v) {
        _vm.$set(_vm.selectedRecord, "amount", $$v)
      },
      expression: "selectedRecord.amount"
    }
  })], 1), _vm._v(" "), (_vm.selectedRecord.image) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Receipt/Proof")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('a', {
    attrs: {
      "href": _vm.selectedRecord.image.Location,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.selectedRecord.image.Location,
      "height": "250",
      "width": "auto"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.deleteRecord
    }
  }, [_vm._v("\n              Delete this Record\n              "), _c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-1"
    },
    on: {
      "click": function($event) {
        _vm.viewPaymentDetailDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-1"
    },
    on: {
      "click": _vm.updateRecord
    }
  }, [_vm._v("Save")])], 1)], 1)])], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Payment records")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f284c8b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Client/AdminPayment.vue
// module id = 2317
// module chunks = 0